module.exports = __webpack_public_path__ + "img/portit.dd2b3b16.png";